import React, { useState } from 'react';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { debounce, noop } from 'lodash';

import { TextFieldSearch } from 'components/v2';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    headerWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      padding: unit * 3,
    },
  });

interface FilterSearchHeaderProps extends WithStyles<typeof styles> {
  onSearchChange: (search: string) => void;
}

const FilterSearchHeader: React.FC<FilterSearchHeaderProps> = ({ classes, onSearchChange = noop }) => {
  const [query, setQuery] = useState('');

  const handleOnChange = (value: string) => {
    setQuery(value);
    debounce(onSearchChange, 600)(value);
  };

  return (
    <div className={classes.headerWrapper}>
      <TextFieldSearch value={query} size="small" onChange={handleOnChange} />
    </div>
  );
};

export default withStyles(styles)(FilterSearchHeader);
